import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoSelect } from 'sharedComponents/select'

const FormasDePagoSunatFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='M. DE PAGO' htmlFor='select-formaDePagoSunat' md={2} />
      <Col md={10}>
        <Field name='_idFormaDePagoSunat'>
          {({ field }) => (
            <MedioPagoSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-formaDePagoSunat'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FormasDePagoSunatFormGroup)
